export enum EnvironmentType {
  Development = 'development',
  Testing = 'testing',
  Production = 'production',
}
